import React from 'react';
import PropTypes from 'prop-types';
import MuiDialogContentText from '@material-ui/core/DialogContentText';

import { componentIdStringGenerator } from '../../../helpers';

const DialogContentText = (props) => {
  return (
    <MuiDialogContentText
      {...props}
      id={componentIdStringGenerator('DialogContentText-description', props.id ?? '')}
    />
  );
};

DialogContentText.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
};

export default DialogContentText;
